<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.ModuleTypeFilter ||
              Filter.PaymentTypeFilter ||
              Filter.JobNoFilter ||
              Filter.TransactionNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.ModuleTypeFilter ||
                  Filter.PaymentTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.TransactionNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

            <!-- Client-side Export using xlsx (exports current paymentList) -->
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              @click="exportToExcelClient" size="sm" variant="success"
              style="font-size: 0.675rem">
              Export (Client XLSX)
            </b-button>

          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date Type</label>
                  <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                    option-text="text" placeholder="Select Date Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Module Type</label>
                  <model-list-select :list="moduleOptions" v-model="Filter.ModuleTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Module Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Payment Type</label>
                  <model-list-select :list="payTypeOptions" v-model="Filter.PaymentTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Payment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Job NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                    id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transaction No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Transaction No Filter"
                    id="TransactionNoFilter" name="TransactionNoFilter" autocomplete="off"
                    v-model="Filter.TransactionNoFilter" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Transport Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Shipment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                    v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                    v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                    v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                    v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="text"
                    option-text="value" placeholder="Select Status"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <!-- Tabs for All vs Bookmarked -->
        <b-tabs v-model="tabIndex" class="mb-2" @input="onTabChange">
          <b-tab title="All"></b-tab>
          <b-tab title="Bookmarks"></b-tab>
        </b-tabs>

        <div class="row" v-if="tabIndex === 0 || tabIndex === 1">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <!-- Bulk actions toolbar -->
              <div class="d-flex align-items-center mb-2" v-if="paymentList && paymentList.length">
                <!-- Select all visible -->
                <b-button size="xs" variant="outline-secondary" class="p-1 mr-2" @click="selectAllVisible"
                  title="Select all on this page" style="font-size: 0.9rem; line-height: 1;">Select all
                </b-button>
                <!-- Deselect all visible -->
                <b-button size="xs" variant="outline-secondary" class="p-1 mr-2" @click="deselectAllVisible"
                  title="Deselect all on this page" style="font-size: 0.9rem; line-height: 1;">Deselect all
                </b-button>

                <b-button size="xs" variant="outline-success" class="p-1 mr-2" @click="openMarkPaidBulk"
                  :title="`Mark Completed (${(selectedCheckBoxRows || []).length})`"
                  style="font-size: 0.9rem; line-height: 1;">Mark Completed
                </b-button>
                <b-button size="xs" variant="outline-danger" class="p-1" @click="selectedCheckBoxRows = []"
                  title="Clear selection" style="font-size: 0.9rem; line-height: 1;">Clear selection
                </b-button>
              </div>

              <b-table show-empty stacked="md" responsive :items="paymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">


                <template slot="head(checkbox)" slot-scope="h">
                  <b-form-checkbox :indeterminate="isHeaderIndeterminate" :checked="isHeaderChecked"
                    @change="toggleSelectAll($event)" title="Select/Deselect all on this page" />
                </template>

                <template slot="head(bookmark)" slot-scope="h">
                  <span title="Bookmark">Fav</span>
                </template>

                <template slot="bookmark" slot-scope="row0">
                  <b-button size="xs" variant="outline-warning" class="p-1 mr-1"
                    @click="toggleBookmark(row0.item)" :title="isBookmarked(row0.item) ? 'Remove bookmark' : 'Add bookmark'"
                    style="font-size: 0.9rem; line-height: 1;">
                    <md-icon style="font-size: 16px; color: #f3a000;">
                      {{ isBookmarked(row0.item) ? 'star' : 'star_border' }}
                    </md-icon>
                  </b-button>
                </template>

                <template slot="checkbox" slot-scope="row0">
                  <div class="d-flex align-items-center">
                    <!-- Toggle details: icon-only -->
                    <b-button @click="onToggleDetails(row0)" size="xs" variant="outline-info" class="p-1 mr-1"
                      title="Show/Hide details" style="font-size: 0.9rem; line-height: 1;">
                      <md-icon style="font-size: 16px;">
                        {{ row0.detailsShowing ? "expand_less" : "expand_more" }}
                      </md-icon>
                    </b-button>

                    <!-- Mark Completed: icon-only -->
                    <b-button size="xs" variant="success" class="p-1 mr-2" @click="openMarkPaid(row0.item)"
                      title="Mark Completed" style="font-size: 0.9rem; line-height: 1;">
                      <md-icon style="font-size: 16px;">check_circle</md-icon>
                    </b-button>

                    <b-form-checkbox v-model="selectedCheckBoxRows" :value="{
                      isParent: true,
                      ApeId: row0.item.TransactionId,
                      ModuleId: row0.item.ModuleId,
                      JobNo: row0.item.JobNo,
                      TransactionNo: row0.item.TransactionNo,
                      PaymentType: row0.item.PaymentType,
                      IsPaymentDone: row0.item.IsPaymentDone,
                      InvPayStatus: row0.item.InvPayStatus,
                    }" />
                  </div>
                </template>
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="invoiceNumber" slot-scope="row1">
                  <strong>Trans No:</strong> {{ row1.item.TransactionNo }}<br />
                  <strong>Request Date:</strong> {{ row1.item.CreatedAt }}<br />
                  <strong>Request By:</strong> {{ row1.item.RequestedBy }}<br />
                  <strong>Status:</strong>  <b-badge :variant="row1.item.IsPaymentDone==1 ? 'success' : 'warning'">
                                    {{ row1.item.IsPaymentDone==1 ? 'Paid' : 'Pending' }}
                                  </b-badge><br />
                  <Assignment-Summary v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                    :title="'Shipment Summary Tracking - '" :assign_date="row1.item.JobDate"
                    :assign_job_type="row1.item.MJobType"
                    :assign_raised_from="'Raised From: ' + row1.item.JobRaisedFrom"
                    :assign_raised_by="'Raised By: ' + row1.item.raisedBy" :fk_all_module_id="row1.item.ModuleId"
                    :jb_series="row1.item.JobNo" :fk_client_id="''" :fk_pod_id="''" />
                  <b-button v-if="$sessionsStorage.get('is_Mobile') != 'port'" size="sm" class="mt-2"
                    style="font-size: 0.675rem" @click="showDocModal(row1.item)" variant="outline-info">Summary &
                    Documents</b-button>
                </template>

                <template slot="JobNo" slot-scope="row1">
                  <strong>Job No:</strong> {{ row1.item.JobNo }}<br />
                  <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
                  <strong>Job Raised By:</strong> {{ row1.item.JobRaisedBy }}<br />
                  <strong>Branch:</strong> {{ row1.item.Branch }}<br />
                  <AssignmentSplitMergeSummary v-if="row1.item.ModuleId"
                    :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="row1.item.ModuleId" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.MJobType" :PMC_AgentType="''" :PMC_Client="row1.item.Client"
                    :PMC_Sline="row1.item.Sline" />
                  <JobWisePaymentsDetails v-if="row1.item.ModuleId" :allModuleId="Number(row1.item.ModuleId)"
                    :JobNo="row1.item.JobNo" />
                </template>

                <template slot="ClientName" slot-scope="row1">
                  <strong>Sline Name:</strong> {{ row1.item.SlineName }}<br />
                  <strong>Client:</strong> {{ row1.item.ClientName }}<br />
                  <InvExpSummary v-if="row1.item.ModuleId" :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="row1.item.ModuleId" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.MJobType" :PMC_AgentType="''" :PMC_Client="row1.item.Client"
                    :PMC_Sline="row1.item.Sline" />
                  <ContainerSummary v-if="row1.item.ModuleId"
                    :PMC_title="'Container Summary Job No - ' + row1.item.JobNo" :PMC_JOBID="row1.item.ModuleId"
                    :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate" :PMC_JOBTYPE="row1.item.MJobType"
                    :PMC_AgentType="''" :PMC_Client="row1.item.Client" :PMC_Sline="row1.item.Sline" />
                </template>

                <template slot="POR" slot-scope="row1">
                  <strong>POR:</strong> {{ row1.item.POR }}<br />
                  <strong>POL:</strong> {{ row1.item.POL }}<br />
                  <strong>POD:</strong> {{ row1.item.POD }}<br />
                  <strong>FPOD:</strong> {{ row1.item.FPOD }}<br />
                </template>

                <!-- Expandable Row for Additional Details -->

                <template slot="row-details" slot-scope="row4">
                  <b-card style="background: whiteSmoke">
                    <b-row>
                      <b-col cols="12" class="mb-2" v-if="row4.item._childrenLoading">
                        <span>Loading child items...</span>
                      </b-col>
                      <b-col cols="12" class="mb-2" v-if="row4.item.children && row4.item.children.length">

                        <div class="table-responsive">
                          <table class="table table-sm mb-0" v-if="row4.item.PaymentType == 2">
                            <thead class="thead-light">
                              <tr>
                                <th style="width: 30px;">
                                  <b-form-checkbox :indeterminate="isChildrenIndeterminate(row4.item)"
                                    :checked="areAllChildrenSelected(row4.item)"
                                    @change="toggleSelectAllChildren(row4.item, $event)"
                                    title="Select/Deselect all items" />
                                </th>
                                <th>Trans No</th>
                                <th>AMT</th>
                                <th>Particular</th>
                                <th>Currency</th>
                                <th>Bill To Customer</th>
                                <th>Selling AMT</th>
                                <th>Pay Mode</th>
                                <th>Pay Ref No</th>
                                <th>Pay Date</th>
                                <th>Pay Amount</th>
                                <th>Pay Status</th>
                                <th>Remarks</th>
                                <th style="width: 80px;">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(ch, idx) in row4.item.children"
                                :key="`${ch.id || ch.ape_transaction_no || 'row'}-${idx}`">
                                <td>
                                  <input type="checkbox" :disabled="ch.InvPayStatus == 1"
                                    :value="childKey(ch, row4.item, idx)" v-model="selectedChildRows"
                                    @change="onChildToggle(row4.item, ch, idx)" />
                                </td>
                                <td>{{ ch.ape_transaction_no }}</td>
                                <td>{{ ch.inv_amt }}</td>
                                <td>{{ ch.ledgermaster_relation && ch.ledgermaster_relation.ledger }}</td>
                                <td>{{ ch.master_currency_relation && ch.master_currency_relation.currencyCode }}</td>
                                <td>{{ ch.sc_category }}</td>
                                <td>{{ ch.selling_amt }}</td>
                                <td>{{ ch.inv_pay_mode }}</td>
                                <td>{{ ch.inv_pay_ref_no }}</td>
                                <td>{{ ch.inv_pay_date }}</td>
                                <td>{{ ch.inv_pay_amt }}</td>
                                <td>
                                  <b-badge :variant="ch.InvPayStatus==1 ? 'success' : 'warning'">
                                    {{ ch.InvPayStatus==1 ? 'Paid' : 'Pending' }}
                                  </b-badge>
                                </td>
                                <td>{{ ch.sc_remark }}</td>
                                <td>
                                  <b-button  :disabled="ch.InvPayStatus == 1" size="xs" variant="success" class="p-1" title="Mark this item as completed"
                                    @click="openMarkPaidChild(ch, row4.item, 'singleChild')"
                                    style="font-size: 0.9rem; line-height: 1;">Pay3
                                  </b-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- Actions toolbar for additional task children -->
                          <div class="mt-2 d-flex align-items-center" style="gap: 8px;">

                            <b-button size="xs" variant="primary" class="p-1"
                              @click="openMarkPaidBulkChildren(row4.item)"
                              :disabled="selectedCountForParent(row4.item) < 2"
                              :title="selectedCountForParent(row4.item) >= 2 ? `Mark Selected (${selectedCountForParent(row4.item)}) as Completed` : 'Select 2 or more items'"
                              style="font-size: 0.9rem; line-height: 1;">
                              Pay1
                            </b-button>
                          </div>
                          <table class="table table-sm mb-0" v-if="row4.item.PaymentType == 1">
                            <thead class="thead-light">
                              <tr>
                                <th style="width: 30px;">
                                  <b-form-checkbox :indeterminate="isChildrenIndeterminate(row4.item)"
                                    :checked="areAllChildrenSelected(row4.item)"
                                    @change="toggleSelectAllChildren(row4.item, $event)"
                                    title="Select/Deselect all items" />
                                </th>
                                <th>Trans No</th>
                                <th>Inv Date</th>
                                <th>NOE</th>
                                <th>Pay Mode</th>
                                <th>Pay Ref No</th>
                                <th>Pay Date</th>
                                <th>Pay Amount</th>
                                <th>Pay Status</th>
                                <th>Remarks</th>
                                <th>Inv Doc</th>
                                <th style="width: 80px;">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(ch, idx) in row4.item.children"
                                :key="`${ch.id || ch.ape_transaction_no || 'row'}-${idx}`">
                                <td>
                                  <input type="checkbox" :disabled="ch.InvPayStatus == 1"
                                    :value="childKey(ch, row4.item, idx)" v-model="selectedChildRows" />
                                </td>
                                <td>{{ ch.ape_transaction_no }}</td>
                                <td>{{ ch.inv_date }}</td>
                                <td>{{ ch.nature_of_expense_relation && ch.nature_of_expense_relation.nature_name }}
                                </td>
                                <td>{{ ch.inv_pay_mode }}</td>
                                <td>{{ ch.inv_pay_ref_no }}</td>
                                <td>{{ ch.inv_pay_date }}</td>
                                <td>{{ ch.inv_pay_amt }}</td>
                                <td>
                                  <b-badge :variant="ch.InvPayStatus==1 ? 'success' : 'warning'">
                                    {{ ch.InvPayStatus==1 ? 'Paid' : 'Pending' }}
                                  </b-badge>
                                </td>
                                <td>{{ ch.sc_remark }}</td>
                                <td>
                                  <div v-if="ch && ch.inv_doc_url">
                                    <b-button size="xs" style="font-size: 0.675rem" variant="warning"
                                      :href="String(ch.inv_doc_url).startsWith('http') ? ch.inv_doc_url : `${docURL}${ch.inv_doc_url}`"
                                      target="_blank" rel="noopener">
                                      View Doc
                                    </b-button>
                                  </div>
                                </td>
                                <td>
                                  <b-button :disabled="ch.InvPayStatus == 1" size="xs" variant="success" class="p-1" title="Mark this item as completed"
                                    @click="openMarkPaidChild(ch, row4.item, 'singleChild')"
                                    style="font-size: 0.9rem; line-height: 1;">
                                    Pay2
                                  </b-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.invoiceType">
                        <span><b>Inv Type:</b> {{ row4.item.invoiceType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.invoiceCategory">
                        <span><b>Inv Category :</b> {{ row4.item.invoiceCategory }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.currency">
                        <span><b>Inv Currency :</b> {{ row4.item.currency }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.slineBlNo">
                        <span><b>Inv Bl No :</b> {{ row4.item.slineBlNo }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.dueDate">
                        <span><b>Due Date :</b> {{ row4.item.dueDate }}<br /></span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.sobDate"><span><b>Sob Date :</b> {{
                        row4.item.sobDate }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.paymentCreatedBy"><span><b>Inv Created By :</b>
                          {{ row4.item.paymentCreatedBy }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MJobType"><span><b>Job Type :</b>{{
                        row4.item.MJobType }}<br /></span></b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.JobTransportType">
                        <span><b>Transport Type:</b> {{ row4.item.JobTransportType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.JobTContainerType">
                        <span><b>Container Type:</b> {{ row4.item.JobTContainerType }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.Branch">
                        <span><b>Raised From:</b> {{ row4.item.Branch }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.RaisedBy">
                        <span><b>Raised By:</b> {{ row4.item.RaisedBy }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.HBL">
                        <span><b>HBL:</b> {{ row4.item.HBL }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBL">
                        <span><b>MBL:</b> {{ row4.item.MBL }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBLDate">
                        <span><b>MBL Date:</b> {{ row4.item.MBLDate }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.MBLReleaseDate">
                        <span><b>MBL Release Date:</b> {{ row4.item.MBLReleaseDate }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.ExpClientName">
                        <span><b>Exp Client Name:</b> {{ row4.item.ExpClientName }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.ImpClientName">
                        <span><b>Imp Client Name:</b> {{ row4.item.ImpClientName }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.POD">
                        <span><b>POD:</b> {{ row4.item.POD }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.FPOD">
                        <span><b>FPOD:</b> {{ row4.item.FPOD }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.Pickup">
                        <span><b>PICK:</b> {{ row4.item.Pickup }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.Stuff">
                        <span><b>STUFF:</b> {{ row4.item.Stuff }}</span>
                      </b-col>
                      <b-col md="3" class="mb-2" v-if="row4.item.Handover">
                        <span><b>HAND:</b> {{ row4.item.Handover }}</span>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>


              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
        <!-- Bulk Payment Modal Component -->
        <BulkPaymentModal
          :show="markPaidBulk.show"
          :selectedItems="getBulkPaymentItems()"
          :payModeOptions="payModeOptions"
          :isLoading="isLoading"
          @close="closeBulkPaymentModal"
          @submit="handleBulkPaymentSubmit"
          @error="handleBulkPaymentError"
        />
        
        <!-- Single Payment Modal -->
        <b-modal 
          id="mark-paid-single-modal" 
          v-model="markPaidSingle.show" 
          title="Mark Payment as Completed"
          hide-footer
          no-close-on-esc
          no-close-on-backdrop
        >
          <div v-if="isLoading" class="text-center p-4">
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <!-- Payment Details Display -->
            <b-card v-if="markPaidSingle.item" class="mb-3">
            <b-row>
              <b-col md="6">
                  <strong>Transaction No:</strong> {{ markPaidSingle.item.TransactionNo || markPaidSingle.item.transactionNo || '-' }}
                </b-col>
                <b-col md="6">
                  <strong>Job No:</strong> {{ markPaidSingle.item.JobNo || markPaidSingle.item.jobNo || '-' }}
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="6">
                  <strong>Type:</strong> 
                  <b-badge :variant="markPaidSingle.item.PaymentType == 1 ? 'info' : (markPaidSingle.item.PaymentType == 2 ? 'secondary' : 'light')">
                    {{ markPaidSingle.item.PaymentType == 1 ? 'Exp' : (markPaidSingle.item.PaymentType == 2 ? 'Additional Task' : '-') }}
                  </b-badge>
                </b-col>
                <b-col md="6">
                  <strong>Amount:</strong> {{ markPaidSingle.item.inv_amt || markPaidSingle.item.selling_amt || '-' }}
                </b-col>
              </b-row>
            </b-card>
            
            <!-- Payment Form -->
            <b-form>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Pay Mode" label-for="single-pay-mode">
                    <b-form-select
                      id="single-pay-mode"
                      v-model="markPaidSingle.inv_pay_mode"
                      :options="payModeOptions"
                      :state="markPaidSingle.inv_pay_mode ? null : false"
                    >
                      <option value="">Select Pay Mode</option>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                  <b-form-group label="Reference No" label-for="single-ref-no">
                    <b-form-input
                      id="single-ref-no"
                      v-model.trim="markPaidSingle.inv_pay_ref_no"
                      placeholder="Reference No"
                      :state="markPaidSingle.inv_pay_ref_no ? null : false"
                    />
                </b-form-group>
              </b-col>
              </b-row>
              <b-row>
              <b-col md="6">
                  <b-form-group label="Amount" label-for="single-amt">
                    <b-form-input
                      id="single-amt"
                      type="number"
                      step="0.01"
                      min="0"
                      v-model.number="markPaidSingle.inv_pay_amt"
                      placeholder="Amount"
                      :state="markPaidSingle.inv_pay_amt !== null && Number(markPaidSingle.inv_pay_amt) > 0 ? null : false"
                    />
                </b-form-group>
              </b-col>
              <b-col md="6">
                  <b-form-group label="Payment Date" label-for="single-date">
                    <b-form-input
                      id="single-date"
                      type="date"
                      v-model="markPaidSingle.inv_pay_date"
                      :state="markPaidSingle.inv_pay_date ? null : false"
                    />
                </b-form-group>
              </b-col>
            </b-row>
            </b-form>
            
            <!-- Action Buttons -->
            <div class="d-flex justify-content-end mt-3">
              <b-button variant="outline-secondary" class="mr-2" @click="closeSinglePaymentModal" :disabled="isLoading">
                Cancel
              </b-button>
              <b-button variant="primary" @click="submitSinglePayment" :disabled="isLoading || !isSinglePaymentValid">
                <b-spinner v-if="isLoading" small class="mr-2"></b-spinner>
                {{ isLoading ? 'Processing...' : 'Save Payment' }}
              </b-button>
            </div>
          </div>
        </b-modal>
        
        <!-- Bulk Children Payment Modal -->
        <!-- <b-modal id="mark-paid-bulk-children" v-model="markPaidBulk.show" title="Mark Selected Payments as Completed"
          hide-footer>
          <div>
            
            <b-alert show variant="secondary" v-if="(markPaidBulk.rows || []).length">
              This will mark all selected child items as completed. You can extend this to collect pay details per item
              if
              needed.
            </b-alert>
          </div>
          <div class="d-flex justify-content-end">
            <b-button variant="outline-secondary" class="mr-2" @click="markPaidBulk.show = false">Close</b-button>
            <b-button variant="primary" @click="submitMarkPaidBulkChildren" :disabled="isLoading">
              {{ isLoading ? 'Please wait...' : 'Confirm' }}
            </b-button>
          </div>
        </b-modal> -->
      </b-card-text>
    </b-card>
    <b-modal class="modal-dialog-doc" size="xl" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
      :title="'Assignment Summary & Documents - ' + JOBSERIES">
      <div v-if="ALLMODULE">
        <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
      </b-button>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE_DOC } from "../../helper/constant";
import PaymentRequestService from "../../services/PaymentRequestService";
import { exportPaymentListToExcel } from "../../helper/ExcelExportHelper";

import DocForm from "../allModuleForm/docLibrary.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import BulkPaymentModal from "../common/BulkPaymentModal.vue";
import * as XLSX from "xlsx";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),

    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function
        
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });
        if (globalPermissionStatus("Expense Access")) {
          this.$store.dispatch("setCurrentRoute", "/payment/purchase");
          if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
            this.fetchLastPage(this.lastVisitPage);
          } else {
            this.getPaymentList("Normal", "0", "0", "1", "1");
          }
        } else {
          this.$router.push({
            path: "/dashboard",
          });
        }
   
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {

      ALLMODULE: "",
      JOBSERIES: "",
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export And Import",
      visible: false,
      paymentList: [],
      totalData: 0,

      payTypeOptions: [
        {
          text: "",
          value: "All",
        },
        {
          Val: "0",
          Text: "Sline",
        },
        {
          Val: "1",
          Text: "Expense",
        },
        {
          Val: "2",
          Text: "Additional Task",
        },
      ],

      moduleOptions: [
        {
          Val: "0",
          Text: "Normal",
        },
        {
          Val: "1",
          Text: "consolidation",
        },
        {
          Val: "2",
          Text: "MISC",
        },
        {
          Val: "3",
          Text: "YARD",
        },
        {
          Val: "4",
          Text: "IB",
        },
      ],

      selectedCheckBoxRows: [],
      isParentSelected: false,
      childType: "",
      PaymentFields: [
        {
          key: 'checkbox',    
          mainkey: "checkbox",
          label: 'Select',         
          sortable: false,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: 'bookmark',
          mainkey: 'bookmark',
          label: 'Fav',
          sortable: false,
          sortDirection: 'ASC',
          table: 'A.',
        },
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "invoiceNumber",
          mainkey: "invoiceNumber",
          label: "Trans Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/Sline Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Loc Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,


      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "2",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
      isInfiniteAppend: false,
      hasMore: true,
      scrollThreshold: 200,

      selectedChildRows: [],
      markPaidBulk: { show: false, rows: [], inv_pay_mode: '', inv_pay_ref_no: '', inv_pay_amt: null, inv_pay_date: '' },
      markPaidSingle: { show: false, item: null, inv_pay_mode: '', inv_pay_ref_no: '', inv_pay_amt: null, inv_pay_date: '', isParent: false, childType: '' },
      statusList: [
        {
          text: 0,
          value: "PENDING",
        },
        {
          text: 1,
          value: "COMPLETED",
        },
        {
          text: 2,
          value: "All",
        },
      ],
      payModeOptions: [
        { value: 'VIA VATECH', text: 'VIA VATECH' },
        { value: 'ONLINE', text: 'ONLINE' },
      ],
      bookmarkedIds: [],
      // Tabs
      tabIndex: 0,
      // Bookmarks list & pagination
      is_bookmark: "0",
      bookmarkedList: [],
      bookmarkedTotal: 0,
      bookmarkedPagination: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50],
      },
    };
  },

  components: {
    CustomLoader,
    ModelListSelect,
    DateRangePicker,

    DocForm,
    BookingTrack,
    JobWisePaymentsDetails,
    AssignmentSplitMergeSummary,
    ContainerSummary,
    InvExpSummary,
    AssignmentSummary,
    BulkPaymentModal,
  },
  computed: {
    isMarkPaidValid() {
      return (
        !!this.markPaidBulk.inv_pay_mode &&
        !!this.markPaidBulk.inv_pay_ref_no &&
        this.markPaidBulk.inv_pay_amt !== null &&
        Number(this.markPaidBulk.inv_pay_amt) > 0 &&
        !!this.markPaidBulk.inv_pay_date
      );
    },
    isSinglePaymentValid() {
      return (
        !!this.markPaidSingle.inv_pay_mode &&
        !!this.markPaidSingle.inv_pay_ref_no &&
        this.markPaidSingle.inv_pay_amt !== null &&
        Number(this.markPaidSingle.inv_pay_amt) > 0 &&
        !!this.markPaidSingle.inv_pay_date
      );
    },
    isHeaderChecked() {
      const visible = this.visibleRowIds;
      return visible.length > 0 && visible.every(v => this.isRowSelected(v));
    },
    isHeaderIndeterminate() {
      const visible = this.visibleRowIds;
      const selectedCount = visible.filter(v => this.isRowSelected(v)).length;
      return selectedCount > 0 && selectedCount < visible.length;
    },
    visibleRowIds() {
      if (!Array.isArray(this.paymentList)) return [];
      return this.paymentList.map(r => ({
        isParent: true,
        ApeId: r.TransactionId,
        ModuleId: r.ModuleId || r.JobId,
        JobNo: r.JobNo,
        TransactionNo: r.TransactionNo,
        PaymentType: r.PaymentType,
        IsPaymentDone: r.IsPaymentDone,
        InvPayStatus: r.InvPayStatus,
      }));
    },
  },
  watch: {
    // Watch for filter changes and reset selections
    Filter: {
      handler(newVal, oldVal) {
        // Skip initial load (when oldVal is undefined)
        if (oldVal === undefined) return;
        
        // Check if any filter actually changed
        const filtersChanged = 
          newVal.ModuleTypeFilter !== oldVal.ModuleTypeFilter ||
          newVal.PaymentTypeFilter !== oldVal.PaymentTypeFilter ||
          newVal.DateTypeFilter !== oldVal.DateTypeFilter ||
          newVal.JobNoFilter !== oldVal.JobNoFilter ||
          newVal.TransactionNoFilter !== oldVal.TransactionNoFilter ||
          newVal.clientFilter !== oldVal.clientFilter ||
          newVal.slineFilter !== oldVal.slineFilter ||
          newVal.TransportTypeFilter !== oldVal.TransportTypeFilter ||
          newVal.ShipemntTypeFilter !== oldVal.ShipemntTypeFilter ||
          newVal.PORFilter !== oldVal.PORFilter ||
          newVal.POLFilter !== oldVal.POLFilter ||
          newVal.PODFilter !== oldVal.PODFilter ||
          newVal.FPODFilter !== oldVal.FPODFilter ||
          newVal.statusFilter !== oldVal.statusFilter ||
          newVal.commonFilter !== oldVal.commonFilter ||
          newVal.createdByFilter !== oldVal.createdByFilter ||
          newVal.branchFilter !== oldVal.branchFilter ||
          newVal.dateRange.startDate !== oldVal.dateRange.startDate ||
          newVal.dateRange.endDate !== oldVal.dateRange.endDate ||
          newVal.startDate !== oldVal.startDate ||
          newVal.endDate !== oldVal.endDate;
        
        if (filtersChanged) {
          // Reset selected items when filters change
          this.selectedCheckBoxRows = [];
          this.selectedChildRows = [];
        }
      },
      deep: true,
    },
    // Also watch tab changes
    tabIndex(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        // Reset selections when switching tabs
        this.selectedCheckBoxRows = [];
        this.selectedChildRows = [];
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    onTabChange(i) {
      this.is_bookmark=i;
      // If switched to Bookmarks tab, fetch list
      if (i === 1) {
        this.getBookmarkedList();
      }else if (i === 0) {
        this.getPaymentList("Normal", "0", "0", "1", "1")
      }
    },
    getBookmarkedList() {
      // const payload = {
      //   page: this.bookmarkedPagination.currentPage,
      //   pageSize: this.bookmarkedPagination.perPage,
      //   // you can pass filter/sort if backend supports it
      // };
      // this.isLoading = true;
      this.getPaymentList("Normal", "0", "0", "1", "1")
      // PaymentRequestService.getBookmarkedPayments(payload)
      //   .then(({ data }) => {
      //     const list = data && Array.isArray(data.data) ? data.data : [];
      //     this.bookmarkedList = list;
      //     if (data && data.pagination) {
      //       this.bookmarkedTotal = data.pagination.totalCount || list.length;
      //       this.bookmarkedPagination.currentPage = data.pagination.currentPage || this.bookmarkedPagination.currentPage;
      //       this.bookmarkedPagination.perPage = data.pagination.pageSize || this.bookmarkedPagination.perPage;
      //     } else {
      //       this.bookmarkedTotal = list.length;
      //     }
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    },
    onBookmarksPageChange(event) {
      this.bookmarkedPagination.currentPage = event;
      this.getBookmarkedList();
    },
    async fetchBookmarksFromApi() {
      try {
        const { data } = await PaymentRequestService.getBookmarks({});
        const list = data && Array.isArray(data.data) ? data.data : [];
        const ids = list.map(x => {
          const v = (x && (x.transactionId || x.TransactionId || x.ape_id || x.ApeId || x.id)) || x;
          return v != null ? String(v) : '';
        }).filter(Boolean);
        this.bookmarkedIds = Array.from(new Set(ids));
      } catch (e) {
        // on failure, clear bookmarks (no local storage fallback)
        this.bookmarkedIds = [];
      }
    },
    // Deprecated: no localStorage usage
    loadBookmarks() { this.bookmarkedIds = []; },
    saveBookmarks() { /* no-op: API only */ },
    rowKeyForBookmark(item) {
      return String(item && (item.TransactionId || item.id || item.id_email_section || item.TransactionNo));
    },
    isBookmarked(item) {
      const key = this.rowKeyForBookmark(item);
      return (this.bookmarkedIds || []).includes(key);
    },
    async toggleBookmark(item) {
      const key = this.rowKeyForBookmark(item);
      const set = new Set(this.bookmarkedIds || []);
      const wasBookmarked = set.has(key);
      const nextState = !wasBookmarked;
      // Optimistic update
      if (nextState) set.add(key); else set.delete(key);
      this.bookmarkedIds = Array.from(set);
      const txnIdNum = isNaN(Number(key)) ? key : Number(key);
      try {
        await PaymentRequestService.upsertBookmark({ transactionId: txnIdNum, isBookmarked: nextState });
      } catch (e) {
        // Revert on failure
        const s2 = new Set(this.bookmarkedIds || []);
        if (nextState) {
          s2.delete(key);
        } else {
          s2.add(key);
        }
        this.bookmarkedIds = Array.from(s2);
      }
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.ModuleId;
      this.JOBSERIES = item.JobNo;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },

    clearFilter() {
      this.Filter = {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "2",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getPaymentList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; 

      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; 
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate, 
        endDate: endDate,     
      };
    },
    getPaymentList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      if (!this.isInfiniteAppend) {
        this.totalData = 0;
        this.paymentList = [];
        this.hasMore = true;
      }
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        ExpImpType: this.ExpImpType,
        is_parent: "1",
        is_include_children: "0",
        is_payment_done: "0",
        is_children: "0",
        is_bookmark: this.is_bookmark,
        payment_type: this.Filter.PaymentTypeFilter,
        module_type: this.Filter.ModuleTypeFilter,

        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.transportTypeFilter,
        shipmentTypeFilter: this.Filter.shipmentTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        branchFilter: this.Filter.branchFilter,
        dateRange: this.Filter.dateRange,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,

        approverByFilter: this.Filter.approverByFilter,
        single: "0",
        isList:1,
      };
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      PaymentRequestService.getPurchaseExpense(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
    
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getPaymentList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalCount;
                this.paymentList = this.isInfiniteAppend ? this.paymentList.concat(data.data) : data.data;
                this.pagination.totalRows = data.pagination.totalCount;
                this.pagination.currentPage = data.pagination.currentPage;
                this.pagination.perPage = data.pagination.pageSize;
                // Prefer robust hasMore when pagination fields exist; fallback to length check
                if (data.pagination && typeof data.pagination.totalPages !== 'undefined') {
                  this.hasMore = Number(data.pagination.currentPage) < Number(data.pagination.totalPages);
                } else {
                  this.hasMore = this.paymentList.length < this.totalData;
                }
                // If content doesn't fill the viewport, auto-load more pages until it does or no more pages
                this.$nextTick(() => {
                  const doc = document.documentElement;
                  const scrollHeight = Math.max(doc.scrollHeight, document.body.scrollHeight);
                  if (scrollHeight <= window.innerHeight && this.hasMore && !this.isLoading) {
                    this.loadMore();
                  }
                });
              }
            }
          }
          this.isLoading = false;
          this.isInfiniteAppend = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore) return;
      const doc = document.documentElement;
      const scrollPosition = window.innerHeight + window.pageYOffset;
      const scrollHeight = Math.max(doc.scrollHeight, document.body.scrollHeight);
      const bottom = scrollHeight - this.scrollThreshold;
      
      if (scrollPosition <= bottom) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.isLoading || !this.hasMore) return;
      this.isInfiniteAppend = true;
      this.pagination.currentPage = (this.pagination.currentPage || 1) + 1;
      this.getPaymentList("Normal", "0", "0", "2", String(this.pagination.currentPage));
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },

    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getPaymentList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getPaymentList("Excell", "0", "0", "1", "1");
    },
    getExpImpReports(id, btnName) {
      this.ExpImpType = "2";
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      this.getPaymentList("Excell", "0", "0", "1", "1");
    },

    // Export to Excel using API helper
    async exportToExcelClient() {
      const payload = {
        type: 'Excel',
        currentPage: 1,
        page: 1,
        perPage: this.totalData || 10000, // Get all records
        pageSize: this.totalData || 10000,
        filter: this.Filter,
        generateExcel: '1',
        is_parent: '1',
        is_include_children: '0',
        is_payment_done: '0',
        is_children: '0',
        is_bookmark: this.is_bookmark,
        payment_type: this.Filter.PaymentTypeFilter,
        module_type: this.Filter.ModuleTypeFilter,
        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.TransportTypeFilter,
        shipmentTypeFilter: this.Filter.ShipemntTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        branchFilter: this.Filter.branchFilter,
        dateRange: this.Filter.dateRange,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,
      };

      const fileName = this.tabIndex === 1 ? 'payment-bookmarks.xlsx' : 'payment-all.xlsx';

      await exportPaymentListToExcel(
        payload,
        fileName,
        true,
        // onStart
        () => {
          this.isLoading = true;
        },
        // onSuccess
        () => {
          this.isLoading = false;
          this.alert.content = 'Excel file downloaded successfully!';
          this.$refs['addPop'].open();
        },
        // onError
        (error) => {
          this.isLoading = false;
          this.alert.content = 'Failed to export Excel. Please try again.';
          this.$refs['addPop'].open();
          console.error('Export error:', error);
        }
      );
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    resetMarkPaidBulkFields() {
      this.markPaidBulk.inv_pay_mode = '';
      this.markPaidBulk.inv_pay_ref_no = '';
      this.markPaidBulk.inv_pay_amt = null;
      this.markPaidBulk.inv_pay_date = '';
    },
    resetSinglePaymentFields() {
      this.markPaidSingle.inv_pay_mode = '';
      this.markPaidSingle.inv_pay_ref_no = '';
      this.markPaidSingle.inv_pay_amt = null;
      this.markPaidSingle.inv_pay_date = '';
    },
    closeSinglePaymentModal() {
      this.markPaidSingle.show = false;
      this.resetSinglePaymentFields();
      this.markPaidSingle.item = null;
    },
    async submitSinglePayment() {
      if (!this.isSinglePaymentValid) {
        this.alert.content = 'Please fill all required fields';
        this.$refs['addPop'].open();
        return;
      }

      try {
        this.isLoading = true;
        const item = this.markPaidSingle.item;
        
        // Build payload for single payment
        let payload;
        
        if (this.markPaidSingle.isParent) {
          // Parent payment
          payload = {
            items: [{
              transactionNo: item.TransactionNo || item.transactionNo,
              JobNo: item.JobNo || item.jobNo,
              ModuleId: item.ModuleId || item.moduleId,
              ApeId: item.ApeId || item.apeId,
              isParentSelected: true,
              children: [],
              invPayMode: this.markPaidSingle.inv_pay_mode,
              invPayRefNo: this.markPaidSingle.inv_pay_ref_no,
              invPayDate: this.markPaidSingle.inv_pay_date,
              invPayAmt: Number(this.markPaidSingle.inv_pay_amt),
            }],
            isParentSelected: true,
            childType: '',
            invPayRemark: '',
          };
        } else {
          // Child payment
          payload = {
            items: [{
              transactionNo: item.TransactionNo || item.transactionNo || item.ape_transaction_no,
              JobNo: item.JobNo || item.jobNo,
              ModuleId: item.ModuleId || item.moduleId,
              parentId: item.ParentId || item.parentId,
              isParentSelected: false,
              children: [item.TransactionId || item.ApeId || item.apeId],
              invPayMode: this.markPaidSingle.inv_pay_mode,
              invPayRefNo: this.markPaidSingle.inv_pay_ref_no,
              invPayDate: this.markPaidSingle.inv_pay_date,
              invPayAmt: Number(this.markPaidSingle.inv_pay_amt),
            }],
            isParentSelected: false,
            childType: this.markPaidSingle.childType || 'singleChild',
            invPayRemark: '',
          };
        }

        // Single payment always uses paymentComplete
        const response = await PaymentRequestService.paymentComplete(payload);
        const { data, status } = response;
        
        if (status === 200 && data) {
          // Close modal and reset
          this.markPaidSingle.show = false;
          this.resetSinglePaymentFields();
          this.markPaidSingle.item = null;
          
          this.alert.content = data.message || 'Payment updated successfully';
          this.$refs['addPop'].open();
          
          // Refresh the list
          this.getPaymentList('Normal', '0', '0', '1', String(this.pagination.currentPage || '1'));
        }
      } catch (e) {
        console.error('submitSinglePayment error', e);
        this.alert.content = 'Failed to update payment. Please try again.';
        this.$refs['addPop'].open();
      } finally {
        this.isLoading = false;
      }
    },
    
    openMarkPaid(row) {
      // Single payment - use single payment modal
      this.markPaidSingle = {
        show: true,
        item: Object.assign({}, row),
        inv_pay_mode: '',
        inv_pay_ref_no: '',
        inv_pay_amt: null,
        inv_pay_date: '',
        isParent: true,
        childType: '',
      };
    },
    
    openMarkPaidChild(child, parent, type) {
      // Single child payment - use single payment modal
      const childItem = Object.assign({}, child, {
        JobNo: parent.JobNo,
        ModuleId: parent.ModuleId,
        ParentId: child.ParentId,
      });
      this.markPaidSingle = {
        show: true,
        item: childItem,
        inv_pay_mode: '',
        inv_pay_ref_no: '',
        inv_pay_amt: null,
        inv_pay_date: '',
        isParent: false,
        childType: type || 'singleChild',
      };
    },

    isSameRow(a, b) {
      return a && b &&
        a.isParent === b.isParent &&
        String(a.ApeId) === String(b.ApeId) &&
        String(a.ModuleId) === String(b.ModuleId) &&
        String(a.JobNo) === String(b.JobNo) &&
        String(a.TransactionNo) === String(b.TransactionNo) &&
        String(a.PaymentType) === String(b.PaymentType) &&
        String(a.IsPaymentDone) === String(b.IsPaymentDone) &&
        String(a.InvPayStatus) === String(b.InvPayStatus);
    },
    isRowSelected(rowKey) {
      return (this.selectedCheckBoxRows || []).some(s => this.isSameRow(s, rowKey));
    },
    toggleSelectAll(checked) {
      this.isParentSelected = true;
      const visible = this.visibleRowIds;
      if (checked) {
        const merged = [...(this.selectedCheckBoxRows || [])];
        visible.forEach(v => {
          if (!merged.some(m => this.isSameRow(m, v))) merged.push(v);
        });
        this.selectedCheckBoxRows = merged;
      } else {
        this.selectedCheckBoxRows = (this.selectedCheckBoxRows || []).filter(
          s => !visible.some(v => this.isSameRow(s, v))
        );
      }
    },
    
    async openMarkPaidBulk() {
      // Check if we have any selections (parent or child)
      const hasParentSelection = this.selectedCheckBoxRows && this.selectedCheckBoxRows.length > 0;
      const hasChildSelection = this.selectedChildRows && this.selectedChildRows.length > 0;
      
      if (!hasParentSelection && !hasChildSelection) {
        this.alert.content = 'Please select at least one payment item';
        this.$refs['addPop'].open();
        return;
      }
      
      // Reset modal state before opening
      this.isParentSelected = hasParentSelection;
      this.resetMarkPaidBulkFields();
      
      // Fetch all children for selected parent payments (like arrow click)
      if (hasParentSelection) {
        this.isLoading = true;
        const fetchPromises = [];
        
        this.selectedCheckBoxRows.forEach((row) => {
          if (row.isParent) {
            // Find parent item from paymentList
            const parentItem = this.paymentList.find(
              (p) => p.TransactionId === row.ApeId || p.TransactionNo === row.TransactionNo
            );
            
            // If children not loaded yet, fetch them
            if (parentItem && (!parentItem.children || !parentItem._childrenLoaded)) {
              const payload = {
                type: 'Normal',
                DCfilterId: '0',
                searchVal: this.filter,
                currentPage: 1,
                page: 1,
                perPage: this.pagination.perPage,
                pageSize: this.pagination.perPage,
                filter: this.Filter,
                generateExcel: '0',
                ExpImpType: this.ExpImpType,
                is_children: '1',
                is_parent: '0',
                is_include_children: '1',
                fk_parent_id: row.ApeId || parentItem.TransactionId,
                fk_module_id: row.ModuleId || parentItem.ModuleId,
                payment_type: this.Filter.PaymentTypeFilter,
                single: '0',
                isList: 1,
              };
              
              const promise = PaymentRequestService.getPurchaseExpense(payload)
                .then(({ data }) => {
                  const list = data && Array.isArray(data.data) ? data.data : [];
                  this.$set(parentItem, 'children', list);
                  this.$set(parentItem, '_childrenLoaded', true);
                  
                  // Auto-select all children for selected parents
                  if (list && list.length > 0) {
                    const childKeys = list.map((ch, idx) => 
                      this.childKey(ch, parentItem, idx)
                    ).filter(Boolean);
                    
                    // Add to selectedChildRows if not already selected
                    const existingKeys = new Set(this.selectedChildRows || []);
                    childKeys.forEach(key => {
                      if (!existingKeys.has(key)) {
                        existingKeys.add(key);
                      }
                    });
                    this.selectedChildRows = Array.from(existingKeys);
                  }
                })
                .catch(() => {
                  this.$set(parentItem, 'children', []);
                });
              
              fetchPromises.push(promise);
            } else if (parentItem && parentItem.children && parentItem.children.length > 0) {
              // Children already loaded - auto-select them
              const childKeys = parentItem.children.map((ch, idx) => 
                this.childKey(ch, parentItem, idx)
              ).filter(Boolean);
              
              const existingKeys = new Set(this.selectedChildRows || []);
              childKeys.forEach(key => {
                if (!existingKeys.has(key)) {
                  existingKeys.add(key);
                }
              });
              this.selectedChildRows = Array.from(existingKeys);
            }
          }
        });
        
        // Wait for all children to be fetched
        await Promise.all(fetchPromises);
        this.isLoading = false;
      }
      
      this.markPaidBulk = { 
        show: true, 
        rows: [], // Clear old rows - will be populated by getBulkPaymentItems()
        inv_pay_mode: '', 
        inv_pay_amt: null, 
        inv_pay_ref_no: '', 
        inv_pay_date: '' 
      };
    },
    selectAllVisible() {
      const visible = this.visibleRowIds;
      this.isParentSelected = true;
      const merged = [...(this.selectedCheckBoxRows || [])];
      visible.forEach(v => {
        if (!merged.some(m => this.isSameRow(m, v))) merged.push(v);
      });
      this.selectedCheckBoxRows = merged;
    },
    deselectAllVisible() {
      this.isParentSelected = false;
      const visible = this.visibleRowIds;
      this.selectedCheckBoxRows = (this.selectedCheckBoxRows || []).filter(
        s => !visible.some(v => this.isSameRow(s, v))
      );
    },
    
    childKey(ch, parent, idx) {
      if (ch.InvPayStatus == false) {

        const i = (typeof idx === 'number') ? idx : -1;
        const id = `${parent.TransactionNo}::${parent.TransactionId}::${ch.TransactionId}::${i}`;
        return id;
      }
    },
    childrenKeys(parent) {
      if (!parent || !Array.isArray(parent.children)) return [];
      return parent.children.map((ch, i) => this.childKey(ch, parent, i));
    },
    areAllChildrenSelected(parent) {
      this.isParentSelected = false;
      const keys = this.childrenKeys(parent);
      if (!keys.length) return false;
      return keys.every(k => (this.selectedChildRows || []).includes(k));
    },
    isChildrenIndeterminate(parent) {
      this.isParentSelected = false;
      const keys = this.childrenKeys(parent);
      if (!keys.length) return false;
      const selected = keys.filter(k => (this.selectedChildRows || []).includes(k)).length;
      return selected > 0 && selected < keys.length;
    },
    toggleSelectAllChildren(parent, checked) {
      this.isParentSelected = false;
      const keys = this.childrenKeys(parent);
      if (!keys.length) return;
      if (checked) {
        const set = new Set(this.selectedChildRows || []);
        keys.forEach(k => set.add(k));
        this.selectedChildRows = Array.from(set);
      } else {
        const remove = new Set(keys);
        this.selectedChildRows = (this.selectedChildRows || []).filter(k => !remove.has(k));
      }
    },
    selectedCountForParent(parent) {
      const keys = this.childrenKeys(parent);
      if (!keys.length) return 0;
      return keys.filter(k => (this.selectedChildRows || []).includes(k)).length;
    },
    openMarkPaidBulkChildren(parent) {
      const keys = new Set(this.childrenKeys(parent));
      const selectedForParent = (this.selectedChildRows || []).filter(k => keys.has(k));
      if (!selectedForParent.length) return;
      const selection = selectedForParent.map(k => ({ key: k }));
      
      // Set up for multi-child payment
      this.isParentSelected = false;
      this.childType = 'multiChild';
      this.resetMarkPaidBulkFields();
      this.markPaidBulk = { 
        show: true, 
        rows: selection, 
        inv_pay_mode: this.markPaidBulk.inv_pay_mode, 
        inv_pay_amt: this.markPaidBulk.inv_pay_amt, 
        inv_pay_ref_no: this.markPaidBulk.inv_pay_ref_no, 
        inv_pay_date: this.markPaidBulk.inv_pay_date 
      };
    },

    parsedBulkData() {
      const rows = this.markPaidBulk.rows;

      return rows.map(r => {
        const parts = r.key.split('::');
        const fullTransactionKey = parts[0];
        const parentId = parts[1];
        const childId = parts[2];
        return {
          transactionNo: fullTransactionKey,
          parentId: parentId,
          childId: childId
        };
      });
    },
    groupedBulkData() {
      const rows = this.markPaidBulk.rows;
      let JobNo = this.markPaidBulk.row.JobNo;
      let ModuleId = this.markPaidBulk.row.ModuleId;

      const groupedMap = rows.reduce((acc, r) => {
        const parts = String(r.key || '').split('::');
        const transactionNo = parts[0];
        const parentId = parts[1];
        const childId = parts[2];

        if (!transactionNo || !parentId) return acc;

        const groupKey = `${transactionNo}::${parentId}`;
        if (!acc[groupKey]) {
          acc[groupKey] = {
            transactionNo,
            parentId,
            children: [],
          };
        }
        if (childId) acc[groupKey].children.push(childId);
        return acc;
      }, {});

      return Object.values(groupedMap).map(group => ({
        JobNo,
        ModuleId,
        isParentSelected: false,
        transactionNo: group.transactionNo,
        parentId: group.parentId,
        children: Array.from(new Set(group.children.filter(Boolean))),
      }));
    },
    allApeIds() {
      const ids = (this.selectedCheckBoxRows || [])
        .map(r => r && r.ApeId)
        .filter(Boolean);
      return Array.from(new Set(ids));
    },
    getBulkPaymentItems() {
      // Only return items when modal is actually showing
      if (!this.markPaidBulk || !this.markPaidBulk.show) {
        return [];
      }
      
      // Get all selected items (both parent and child) - only current selections
      const items = [];

      console.log('getBulkPaymentItems - selectedCheckBoxRows:', this.selectedCheckBoxRows);
      
      // Track all keys that have been added to prevent duplicates
      const addedKeys = new Set();
      
      // Add parent items - only include currently selected ones
      // When parent is selected, add ALL its children (not the parent itself)
      if (this.selectedCheckBoxRows && this.selectedCheckBoxRows.length > 0) {
        this.selectedCheckBoxRows.forEach((row) => {
          if (row.isParent) {
            // Find the full parent item from paymentList
            const parentItem = this.paymentList.find(
              (p) => p.TransactionId === row.ApeId || p.TransactionNo === row.TransactionNo
            );
            if (parentItem) {
              // Don't add parent item itself - only add its children
              // Add ALL children from this parent (like arrow click shows all)
              if (parentItem.children && parentItem.children.length > 0) {
                console.log(`Adding ${parentItem.children.length} children from parent ${row.TransactionNo}`);
                parentItem.children.forEach((childItem, idx) => {
                  const childKey = this.childKey(childItem, parentItem, idx);
                  if (childKey && !addedKeys.has(childKey)) {
                    const parts = String(childKey).split('::');
                    const transactionNo = parts[0];
                    const parentId = parts[1];
                    const childId = parts[2];
                    
                    items.push(Object.assign({}, childItem, {
                      TransactionNo: transactionNo,
                      parentId: parentId,
                      childId: childId,
                      TransactionId: childId,
                      isParent: false,
                      JobNo: parentItem.JobNo,
                      ModuleId: parentItem.ModuleId,
                      key: childKey,
                    }));
                    addedKeys.add(childKey);
                    console.log(`Added child ${childId} from parent ${row.TransactionNo}`);
                  }
                });
              }
            }
          }
        });
      }

      // Add child items - only include currently selected ones (that weren't already added from parent)
      if (this.selectedChildRows && this.selectedChildRows.length > 0) {
        console.log('getBulkPaymentItems - selectedChildRows:', this.selectedChildRows);
        console.log('getBulkPaymentItems - selectedChildRows count:', this.selectedChildRows.length);
        
        this.selectedChildRows.forEach((key, index) => {
          // Skip if already added from parent selection
          if (addedKeys.has(key)) {
            console.log(`Skipping key ${key} - already added from parent`);
            return;
          }
          
          const parts = String(key).split('::');
          console.log(`Processing key ${index}:`, key, 'parts:', parts);
          
          if (parts.length >= 3) {
            const transactionNo = parts[0];
            const parentId = parts[1];
            const childId = parts[2];
            const idx = parts[3]; // Index from key
            
            console.log(`Extracted - transactionNo: ${transactionNo}, parentId: ${parentId}, childId: ${childId}, idx: ${idx}`);
            
            // Find parent item
            const parentItem = this.paymentList.find(
              (p) => p.TransactionId === parentId || p.TransactionNo === transactionNo
            );
            
            if (parentItem && parentItem.children) {
              console.log(`Found parent item with ${parentItem.children.length} children`);
              
              // Find child item by TransactionId - use index from key if available to handle duplicates
              let childItem = null;
              const idxNum = parts[3] ? parseInt(parts[3]) : -1;
              
              if (idxNum >= 0 && idxNum < parentItem.children.length) {
                // Use index if available and valid
                childItem = parentItem.children[idxNum];
                console.log(`Using index ${idxNum} to get child item`);
              } else {
                // Fallback to finding by TransactionId
                childItem = parentItem.children.find(
                  (c) => String(c.TransactionId) === String(childId)
                );
                console.log(`Using TransactionId ${childId} to find child item`);
              }
              
              if (childItem) {
                // Ensure childId is properly set - it should be the TransactionId of the child
                const actualChildId = childId || childItem.TransactionId || '';
                console.log(`Adding child item ${actualChildId} to items array. Current items count: ${items.length}`);
                
                items.push(Object.assign({}, childItem, {
                  TransactionNo: transactionNo,
                  parentId: parentId,
                  childId: actualChildId, // Explicitly set childId
                  TransactionId: actualChildId, // Also set TransactionId to ensure consistency
                  isParent: false,
                  JobNo: parentItem.JobNo,
                  ModuleId: parentItem.ModuleId,
                  key: key, // Use the key for tracking
                }));
                addedKeys.add(key);
                
                console.log(`Successfully added child. New items count: ${items.length}`);
              } else {
                console.warn(`Child item not found for childId: ${childId}, idx: ${idxNum} in parent:`, parentItem);
                console.warn(`Available children TransactionIds:`, parentItem.children.map(c => c.TransactionId));
              }
            } else {
              console.warn(`Parent item not found for transactionNo: ${transactionNo}, parentId: ${parentId}`);
            }
          } else {
            console.warn(`Invalid key format: ${key}, parts length: ${parts.length}`);
          }
        });
        
        console.log('getBulkPaymentItems - Final items count:', items.length);
        console.log('getBulkPaymentItems - Final items:', items);
      }

      return items;
    },
    closeBulkPaymentModal() {
      this.markPaidBulk.show = false;
      this.resetMarkPaidBulkFields();
      // Clear selections when cancel is clicked
      this.selectedCheckBoxRows = [];
      this.selectedChildRows = [];
    },
    handleBulkPaymentError(errorMessage) {
      this.alert.content = errorMessage || 'Please fill all required fields';
      this.$refs['addPop'].open();
    },
    async handleBulkPaymentSubmit(processedItems) {
      try {
        this.isLoading = true;
        
        console.log('handleBulkPaymentSubmit - processedItems:', processedItems);
        console.log('Total items to process:', processedItems.length);
        
        // Separate parent and child items
        const parentItems = [];
        // Group children by parent AND payment details (to handle different payment details per child)
        const childGroupsMap = {};
        
        processedItems.forEach((item) => {
          if (item.isParent) {
            // Parent item format - use ApeId as parentId
            const parentId = item.ApeId || item.TransactionId || '';
            parentItems.push({
              transactionNo: item.TransactionNo || item.transactionNo,
              parentId: parentId,
              JobNo: item.JobNo,
              ModuleId: item.ModuleId,
              isParentSelected: true,
              children: [],
              invPayMode: item.inv_pay_mode,
              invPayRefNo: item.inv_pay_ref_no,
              invPayDate: item.inv_pay_date,
              invPayAmt: item.inv_pay_amt,
            });
          } else {
            // Child item - group by parent transaction only, not by payment details
            // This ensures all children from same transaction are included
            const transactionNo = item.TransactionNo || item.transactionNo || '';
            const parentId = item.parentId || '';
            // Extract childId from key if available, otherwise use TransactionId
            let childId = item.childId || '';
            if (!childId && item.key) {
              const keyParts = String(item.key).split('::');
              if (keyParts.length >= 3) {
                childId = keyParts[2]; // childId is the 3rd part in the key
              }
            }
            if (!childId) {
              childId = item.TransactionId || item.apeId || '';
            }
            
            // Skip if we don't have a valid childId
            if (!childId) {
              console.warn('Missing childId for item:', item);
              return;
            }
            
            // Group by transaction and parent only - each child keeps its own payment details
            const groupKey = `${transactionNo}::${parentId}`;
            
            if (!childGroupsMap[groupKey]) {
              childGroupsMap[groupKey] = {
                transactionNo: transactionNo,
                parentId: parentId,
                JobNo: item.JobNo,
                ModuleId: item.ModuleId,
                isParentSelected: false,
                children: [],
                // Store payment details per child
                childPaymentDetails: {},
              };
            }
            
            // Add child to the group (ensure we don't duplicate)
            const childIdStr = String(childId);
            if (!childGroupsMap[groupKey].children.includes(childIdStr)) {
              childGroupsMap[groupKey].children.push(childIdStr);
              console.log(`Added child ${childIdStr} to group ${groupKey}. Total children in group:`, childGroupsMap[groupKey].children.length);
            } else {
              console.log(`Child ${childIdStr} already exists in group ${groupKey}`);
            }
            
            // Store payment details for this specific child
            childGroupsMap[groupKey].childPaymentDetails[childIdStr] = {
              invPayMode: item.inv_pay_mode || '',
              invPayRefNo: item.inv_pay_ref_no || '',
              invPayDate: item.inv_pay_date || '',
              invPayAmt: item.inv_pay_amt || null,
            };
          }
        });

        // Build final items array
        const allItems = [...parentItems];
        
        // Add child groups - create separate item for each child if they have different payment details
        Object.values(childGroupsMap).forEach((group) => {
          const children = Array.from(new Set(group.children.filter(Boolean)));
          console.log(`Processing group ${group.transactionNo}::${group.parentId} with ${children.length} children:`, children);
          
          // Group children by their payment details
          const paymentGroups = {};
          children.forEach((childId) => {
            const paymentDetails = group.childPaymentDetails[childId] || {};
            const paymentKey = `${paymentDetails.invPayMode || ''}::${paymentDetails.invPayRefNo || ''}::${paymentDetails.invPayDate || ''}::${paymentDetails.invPayAmt || ''}`;
            
            if (!paymentGroups[paymentKey]) {
              paymentGroups[paymentKey] = {
                children: [],
                invPayMode: paymentDetails.invPayMode || '',
                invPayRefNo: paymentDetails.invPayRefNo || '',
                invPayDate: paymentDetails.invPayDate || '',
                invPayAmt: paymentDetails.invPayAmt || null,
              };
            }
            paymentGroups[paymentKey].children.push(childId);
            console.log(`Added child ${childId} to payment group with key: ${paymentKey}`);
          });
          
          console.log(`Created ${Object.keys(paymentGroups).length} payment groups for transaction ${group.transactionNo}`);
          
          // Create separate items for each payment group
          Object.values(paymentGroups).forEach((paymentGroup) => {
            console.log(`Adding item with ${paymentGroup.children.length} children:`, paymentGroup.children);
            allItems.push({
              transactionNo: group.transactionNo,
              parentId: group.parentId,
              JobNo: group.JobNo,
              ModuleId: group.ModuleId,
              isParentSelected: false,
              children: paymentGroup.children,
              invPayMode: paymentGroup.invPayMode,
              invPayRefNo: paymentGroup.invPayRefNo,
              invPayDate: paymentGroup.invPayDate,
              invPayAmt: paymentGroup.invPayAmt,
            });
          });
        });
        
        console.log('Final allItems:', allItems);
        console.log('Total items to send:', allItems.length);

        const payload = {
          items: allItems,
          isParentSelected: parentItems.length > 0,
          childType: Object.keys(childGroupsMap).length > 0 ? 'multiChild' : '',
          invPayRemark: '',
        };

        // Since this is called from BulkPaymentModal, always use multiPaymentComplete
        const response = await PaymentRequestService.multiPaymentComplete(payload);
        const { data, status } = response;
        
        if (status === 200 && data) {
          // Clear selections FIRST before closing modal
          const processedKeys = new Set();
          processedItems.forEach(item => {
            if (item.key) processedKeys.add(item.key);
            if (item.isParent && item.ApeId) {
              processedKeys.add(`${item.TransactionNo}::${item.ApeId}`);
            }
          });
          
          // Remove processed items from selections
          this.selectedCheckBoxRows = (this.selectedCheckBoxRows || []).filter(row => {
            const rowKey = `${row.TransactionNo}::${row.ApeId}`;
            return !processedKeys.has(rowKey);
          });
          
          this.selectedChildRows = (this.selectedChildRows || []).filter(key => {
            return !processedKeys.has(key);
          });
          
          // Close modal and reset
          this.markPaidBulk.show = false;
          this.resetMarkPaidBulkFields();
          
          this.alert.content = data.message || 'Payments updated successfully';
          this.$refs['addPop'].open();
          
          // Refresh the list
          this.getPaymentList('Normal', '0', '0', '1', String(this.pagination.currentPage || '1'));
        }
      } catch (e) {
        console.error('handleBulkPaymentSubmit error', e);
        this.alert.content = 'Failed to update payments. Please try again.';
        this.$refs['addPop'].open();
      } finally {
        this.isLoading = false;
      }
    },
    async submitMarkPaidBulkChildren() {

      try {
        this.markPaidBulk.show = false;
        if (!this.markPaidBulk || !this.markPaidBulk.inv_pay_amt || !this.markPaidBulk.inv_pay_ref_no || !this.markPaidBulk.inv_pay_date) return;
        this.isLoading = true;
        const processed = new Set(this.markPaidBulk.rows.map(r => r.key));
        this.selectedChildRows = (this.selectedChildRows || []).filter(k => !processed.has(k));

        let items = this.isParentSelected ? this.allApeIds() : this.groupedBulkData();
        if(this.childType != ""){
          items = this.childType == "multiChild" ? items : this.markPaidBulk.child;
        }
        let payload = {
          items: items,
          isParentSelected: this.isParentSelected,
          childType: this.childType,
          invPayMode: this.markPaidBulk.inv_pay_mode,
          invPayRefNo: this.markPaidBulk.inv_pay_ref_no,
          invPayDate: this.markPaidBulk.inv_pay_date,
          invPayAmt: this.markPaidBulk.inv_pay_amt,
          invPayRemark: "",
        };
        
        // Determine if it's bulk (multiple items) or single payment
        const totalItems = Array.isArray(items) ? items.length : 0;
        const totalChildren = Array.isArray(items) 
          ? items.reduce((sum, item) => sum + (Array.isArray(item.children) ? item.children.length : 0), 0)
          : 0;
        const isBulkPayment = totalItems > 1 || totalChildren > 1 || this.childType === 'multiChild';
        
        // Use multiPaymentComplete for bulk, paymentComplete for single
        // Note: This method doesn't use BulkPaymentModal, so we check if bulk or single
        const apiMethod = isBulkPayment 
          ? PaymentRequestService.multiPaymentComplete(payload)
          : PaymentRequestService.paymentComplete(payload);
        
        apiMethod.then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("paymentComplete data", data);
            this.isLoading = false;
            this.alert.content = data.message;
            this.$refs["addPop"].open();
            this.getPaymentList('Normal', '0', '0', '1', String(this.pagination.currentPage || '1'));
          }
        })    
        this.childType = "";
      } catch (e) {
        console.error('submitMarkPaidBulkChildren error', e);
      } finally {
        this.isLoading = false;
      }
    },
    openMarkPaidForSelected(parent) {
      const keys = this.childrenKeys(parent);
      if (!keys.length) return;
      const selected = (this.selectedChildRows || []).filter(k => keys.includes(k));
      if (selected.length !== 1) return;
      const key = selected[0];
      const parts = String(key).split('::');
      const idxStr = parts[parts.length - 1];
      const idx = Number(idxStr);
      if (Number.isNaN(idx) || !Array.isArray(parent.children) || !parent.children[idx]) return;
      const child = parent.children[idx];
      this.openMarkPaidChild(child, parent, 'multiChild');
    },
    onChildToggle(parent, child, idx) {
      try {
        this.isParentSelected = false;
        const key = this.childKey(child, parent, idx);
      } catch (e) { }
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    onToggleDetails(rowCtx) {
      const wasShowing = rowCtx.detailsShowing;
      rowCtx.toggleDetails();
      if (!wasShowing && !rowCtx.item._childrenLoaded) {
        this.$set(rowCtx.item, '_childrenLoading', true);
        const payload = {
          type: 'Normal',
          DCfilterId: '0',
          searchVal: this.filter,
          currentPage: 1,
          page: 1,
          perPage: this.pagination.perPage,
          pageSize: this.pagination.perPage,
          filter: this.Filter,
          generateExcel: '0',
          ExpImpType: this.ExpImpType,
          is_children: '1',
          is_parent: '0',
          is_include_children: '1',
          fk_parent_id: rowCtx.item.TransactionId,
          fk_module_id: rowCtx.item.ModuleId,
          payment_type: this.Filter.PaymentTypeFilter,
          single: '0',
          isList:1,
        };
        PaymentRequestService.getPurchaseExpense(payload)
          .then(({ data }) => {
            const list = data && Array.isArray(data.data) ? data.data : [];
            this.$set(rowCtx.item, 'children', list);
            this.$set(rowCtx.item, '_childrenLoaded', true);
          })
          .catch(() => {
            this.$set(rowCtx.item, 'children', []);
          })
          .finally(() => {
            this.$set(rowCtx.item, '_childrenLoading', false);
          });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// getPaymentList.vue?cd508aca